module.exports = __webpack_public_path__ + "media/images/front/banner_minpre_240905-84732a023036265c7dbf5fc786ae5996.jpg";